import OBJ0 from "../assets/mic/shape0_0.obj";
import OBJ1 from "../assets/mic/shape0_1.obj";
import OBJ2 from "../assets/mic/shape0_2.obj";
import OBJ3 from "../assets/mic/shape0_3.obj";
import OBJ4 from "../assets/mic/shape0_4.obj";
import OBJ5 from "../assets/mic/shape0_5.obj";
import OBJ6 from "../assets/mic/shape0_6.obj";
import OBJ7 from "../assets/mic/shape0_7.obj";

import PNG0 from "../assets/mic/shape0.pngfeat0.png";
import PNG1 from "../assets/mic/shape0.pngfeat1.png";

import JSON from "../assets/mic/mlp.json";

const MIC = [OBJ0, OBJ1, OBJ2, OBJ3, OBJ4, OBJ5, OBJ6, OBJ7, PNG0, PNG1, JSON];

export default MIC;
